import { useContext } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableFooter, TablePagination } from '@material-ui/core';
import { CircleLoader, DeleteIconButton, PageContent } from "components";
import { serialNumbersContext } from "../SerialNumbersProvider";

let Results = () => {
    let service = useContext(serialNumbersContext);

    return (
        <PageContent>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Serial number</TableCell>
                                <TableCell>Used by</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.serialNumbers.map(serial =>
                                <TableRow hover key={serial.id}>
                                    <TableCell>{serial.serialNumber}</TableCell>
                                    <TableCell>{serial.isUsed ? serial.usedBy : ''}</TableCell>
                                    <TableCell align="right">
                                        {serial.isUsed === false &&
                                            <DeleteIconButton onClick={async () => service.deleteSerialNumber(serial.id)} />
                                        }
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                        {service.serialNumbers.length === 0 &&
                            <TableFooter>
                                <TableRow>
                                    <TableCell colSpan={3}>
                                        <i>No serial numbers found</i>
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        }
                    </Table>
                    <TablePagination
                        component="div"
                        count={service.recordCount}
                        onPageChange={(e, page) => service.changePage(page)}
                        page={service.search.pageNr}
                        rowsPerPage={service.search.pageSize}
                        rowsPerPageOptions={[service.search.pageSize]}
                        labelDisplayedRows={({ page }) =>
                            <span>Page {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                        }
                    />
                </>
            }
        </PageContent>
    )
}

export default Results;